var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('button',{staticClass:"button is-link",on:{"click":_vm.imprimir}},[_vm._v("Imprimir")]),_vm._v(" "),_c('br'),_c('br'),_vm._v(" "),(
      _vm.data.comprobante &&
      _vm.data.comprobante.esfactura &&
      _vm.data.comprobante.estructura === 'comercial'
    )?_c('y-printcomercialfactura',{attrs:{"id":"printable","data":_vm.data,"total":_vm.total,"registros":_vm.registros,"iva":_vm.iva,"cliente":_vm.cliente,"subtotal":_vm.subtotal,"vencimiento":_vm.vencimiento,"cufe":_vm.cufe}}):_vm._e(),_vm._v(" "),(
      _vm.registros.length > 0 &&
      _vm.data.comprobante &&
      _vm.data.comprobante.estructura === 'factura'
    )?_c('y-printfrapvta',{attrs:{"id":"printable","dataprint":_vm.dataprint,"cufe":_vm.cufe}}):_vm._e()],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-519073f4","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/reports/fraelectronica/Repgrafica.vue
// module id = 682
// module chunks = 0